<template>
<div>
		<header class="">
		<nav class="container">
			<div class="row">
				<div class="col-xs-12">
					<img class="img-responsive logo-head" src="@/assets/images/eas-head.svg" alt="EAS Strategies">
				</div>
			</div>
			<div class="login-title-padding">
				<div class="row">
					<div class="col-xs-12 col-sm-8 col-md-6">
						<div class="password-reset-page-title">In order to reset your password, please enter your account email address and we'll send you a link to set a new password.</div>
					</div>
					<div class="col-xs-12 col-sm-8 col-md-5 col-md-offset-1">
						<div class="">
							<div class="form-group">
								<label for="email-1" class="form-label sr-only">Email</label>
								<input
								v-model="email_address"
								class="form-control"
								name="email"
								type="email"
								placeholder="Email"
								required
							/>
							</div>
							<div class="">
								<b-btn class="btn btn-md btn-success" type="submit" @click="reset">
									Request password reset
								</b-btn>								<div class="">
									<router-link class="btn btn-clear" to="/login" tag="a"
									>Back to login</router-link
								>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</nav>
		<div class="container">
			<div class="row">
			</div>
		</div>
	</header>
	<!--Pre footer-->
	<section class="pre-footer-bg">
	</section>
	<footer>
		<div class="container">
			<div class="row">
				<div class="col-xs-12 logo-container-foot">
					<a href="/">
					<img class="img-responsive logo-foot" src="@/assets/images/eas-head.svg" alt="EAS Strategies">
					</a>
				</div>
			</div>
			<div class="row">
				<div class="col-xs-12 text-center">
					<p>
												<a href="https://eas-strategies.com/" target="_blank">EAS Strategies</a>
						<br class="visible-xs"/>
						<span class="hidden-xs">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
						<a href="https://eas-strategies.com/privacy/" target="_blank">Privacy policy</a>
						<br class="visible-xs"/>
						<span class="hidden-xs">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
						<a href="https://eas-strategies.com/disclaimer/" target="_blank">Disclaimer</a>
						<br />
						<br />
						©  {{currentYear}}  EAS Strategies Ltd.
						<br class="visible-xs"/>
						<span class="hidden-xs">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
						<a href="http://www.bubblegate.co.uk" target="_blank">Built by Bubblegate</a>
					</p>
				</div>
			</div>
		</div>
	</footer>
</div>
</template>

<style lang="less">
.fade-enter-active,
.fade-leave-active {
	transition: opacity 0.5s;
}
.fade-enter,
.fade-leave-to {
	opacity: 0;
}
</style>

<script>
import moment from 'moment';
import { Notification } from 'uiv';

export default {
	created() {
		this.runLoader();
	},
	data() {
		return {
			email_address: null,
			loading: false,
		};
	},
	methods: {
		async reset() {
			try {
				this.$router.push({ path: '/login' });
				await this.$axios.post('/reset-password', { email_address: this.email_address });
				Notification.notify({
					type: 'info',
					title: 'Password reset email sent.',
					duration: 10000,
				});
			} catch (e) {
				Notification.notify({
					type: 'warning',
					title: 'Could not reset password.',
					content: e.response ? e.response.data.message : 'Invalid email',
					duration: 3000,
				});
			}
		},
		runLoader() {
			this.loading = true;
			setTimeout(() => {
				this.loading = false;
			}, 1000);
		},
	},
	computed: {
		currentYear() {
			return moment().format('YYYY');
		},
	},
};
</script>
